module.exports = "/_next/static/images/3182200db8f064751ba790dc10f6b567-purple-man@0.75x.jpg.webp";